import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(lang_pl);

    /** @ngInject */
    function lang_pl($translateProvider) {
        $translateProvider.translations('pl', {
            SOFTWARE_NAME: 'imieszkaniec.pl - System Obsługi Mieszkańca',
            LOGIN_FORM: {
                E_MAIL: 'adres e-mail',
                EBOK: 'numer e-bok',
                LOGIN_WITH_EBOK: 'Zaloguj za pomocą nr E-BOK',
                PASSWORD: 'hasło',
                LOGIN: 'zaloguj',
                FORGET_PASSWORD: 'Zapomniałeś hasła?',
                PASSWORD_REMINDER_TEXT:
                    'Prosimy o wprowadzenie e-maila konta dla którego hasło ma zostać zresetowane.',
                PASSWORD_REMINDER_SEND: 'wyślij',
                SET_NEW_PASSWORD_TEXT: 'Wpisz nowe hasło.',
                SET_NEW_PASSWORD_PASSWORD_1: 'hasło',
                SET_NEW_PASSWORD_PASSWORD_2: 'powtórz hasło',
                VERIFY_ACCOUNT:
                    'Dziękujemy, konto zostało potwierdzone i wysłane do weryfikacji przez administrację. Czas oczekiwania powinien wynieść do dwóch dni roboczych. Informację potwierdzającą zgodność weryfikacji mieszkania otrzymasz e-mailem, wraz z dostępem.',
                VERIFY_ACCOUNT_BY_ADMIN:
                    'Twoje konto w systemie iMieszkaniec.pl zostało założone przez administratora systemu. Wypełnij poniższy formularz, aby móc się zalogować. Hasło powinno zawierać minimum 8 znaków, w tym przynajmniej jedną dużą literę oraz przynajmniej jedną cyfrę lub symbol.',
                CONFIRM:
                    'Konto zostało poprawnie utworzone. Na podany przez Ciebie adres e-mail została wysłana wiadomość z linkiem aktywacyjnym.',
            },
            REGISTRATION: {
                TITLE: 'Rejestracja',
                SUBTITLE:
                    'Wypełnij poniższy formularz, aby zarejestrować się w systemie iMieszkaniec.pl',
                FIRST_NAME: 'Imię',
                LAST_NAME: 'Nazwisko',
                EMAIL: 'E-mail',
                PASSWORD1: 'Hasło',
                PASSWORD2: 'Powtórz hasło',
                PHONE: 'Telefon kontaktowy',
                CORRESPONDENCE_ADDRESS: 'Adres korespondencyjny',
                ID: 'ID',
                ID_TOOLTIP: 'Tooltipa treść',
                PRIVACE_POLICY: 'Akceptuję politykę prywatności',
                REGULATION: 'Akceptuję Regulamin iMieszkaniec.pl',
                PROCESSING: 'Wyrażam zgodę na przetwarzanie danych',
                BUTTON: 'Zarejestruj',
                COMPANY: 'Firma',
                CONTRACTOR_TYPE: 'Typ wykonawcy',
            },
            MAIN_GUI_ELEMENTS: {
                HELLO: 'Witaj',
                BACK: 'powrót',
                SAVE: 'zapisz',
                ADD_NEW: 'dodaj nowy',
                OVERVIEW: 'Przegląd',
                ADMINISTRATION: 'Administracja',
                ABORT: 'anuluj',
            },
            ROUTE_NAMES: {
                SOM: 'Panel główny',
                EMPLOYEE: 'Panel pracownika',
                INHABITANT: 'Panel mieszkańca',
                ACCIDENT: 'System Obsługi Awarii',
                ACCIDENT_SHORT: 'Obsługa Awarii',
                ACCIDENT_WALL: 'Bieżące awarie',
                ACCIDENT_HISTORY: 'Historia Awarii',
                ISSUE_DETAILS: 'Szczegóły Awarii',
                EMPLOYEE_SETTINGS: 'Panel zarządzania',
                EMPLOYEE_SETTINGS_INHABITANT_ACCOUNTS: 'Konta mieszkańców',
                EMPLOYEE_SETTINGS_BUILDINGS: 'Konfiguracja budynków',
                EMPLOYEE_SETTINGS_CREATE_BUILDING: 'Tworzenie budynku',
                EMPLOYEE_SETTINGS_EDIT_BUILDING: 'Edycja budynku',
                EMPLOYEE_SETTINGS_CREATE_BUILDING_PART:
                    'Tworzenie części budynku',
                EMPLOYEE_SETTINGS_EDIT_BUILDING_PART: 'Edycja części budynku',
                EMPLOYEE_SETTINGS_BUILDINGS_DETAILS: 'Szczegóły budynku',
                EMPLOYEE_SETTINGS_STREETS: 'Konfiguracja ulic',
                EMPLOYEE_SETTINGS_CREATE_STREETS: 'Tworzenie ulic',
                EMPLOYEE_SETTINGS_EDIT_STREETS: 'Edycja ulic',
                EMPLOYEE_SETTINGS_ADMINS: 'Konta administratorów',
                EMPLOYEE_SETTINGS_CONSERVATOR: 'Konta wykonawców',
                EMPLOYEE_SETTINGS_DETAILS_CONTRACTOR: 'Szczegóły wykonawcy',
                EMPLOYEE_SETTINGS_CREATE_CONSERVATOR:
                    'Dodawanie nowego wykonawcy',
                EMPLOYEE_SETTINGS_CREATE_ADMINS:
                    'Dodawanie nowego administratora',
                EMPLOYEE_SETTINGS_STANDARD_ISSUE_ACCEPT: 'Zatwierdzanie awarii',
                EMPLOYEE_SETTINGS_NONSTANDARD_ISSUE_ACCEPT:
                    'Niestandardowe zatwierdzanie awarii',
                INHABITANT_SETTINGS: 'Ustawienia użytkownika',
                INHABITANT_SETTINGS_ACCOUNT_SETTINGS: 'Ustawienia konta',
                INHABITANT_SETTINGS_CHANGE_DATA: 'Zmiana ustawień konta',
                INHABITANT_SETTINGS_CHANGE_PASSWORD: 'Zmiana hasła',
                INHABITANT_SETTINGS_MOBILE_APP: 'Aplikacja mobilna',
                INHABITANT_SETTINGS_LOCALS: 'Moje lokale',
                SETTLEMENT: 'Sprawy bieżące',
                REPAIR_PLANS: 'Plany remontów',
                ADD_NEW_REPAIR_PLAN: 'Dodaj nowy plan remontu',
                LEGISLATIVE_ACTS_CATEGORIES: 'Kategorie aktów prawnych',
                LEGISLATIVE_ACTS: 'Akty prawne',
                ADD_NEW_LEGISLATIVE_ACT: 'Dodaj akt prawny',
                EDIT_LEGISLATIVE_ACT: 'Edytuj akt prawny',
                HA_DOCUMENTS: 'Druki dla mieszkańca',
                ADD_NEW_HA_DOCUMENT: 'Dodaj druk',
                EDIT_HA_DOCUMENT: 'Edycja druku',
                EDIT_REPAIR_PLAN: 'Edycja planu remontu',
                CLEANING: 'Syestem Obsługi Sprzątań',
                CLEANING_SHORT: 'Obsługa Sprzątań',
                CALC: 'System Obsługi Rozliczeń',
                CALC_SHORT: 'Obsługa Rozliczeń',
                PAYMENT: 'System Obsługi Rozliczeń',
                CALCULATION: 'Szczegóły salda',
                ALL_MONTHS: 'Wszystkie miesiące',
                ACCOUNT_ANALYSIS: 'Analiza konta',
                CONTRACTOR: 'Panel wykonawcy',
            },
            POPUPS: {
                DELETE_POPUP: 'Czy chcesz usunąć ten element?',
                DELETE_CONFIRM: 'usuń',
                DELETE_ABORT: 'anuluj',
            },
            EMPLOYEE_SETTINGS_MENU: {
                BUILDINGS: 'Konfiguracja budynków',
                BUILDINGS_SUB:
                    'Zarządzaj budynkami, przypisz budynek do nieruchomości, przypisz ulicę do budynku',
                STREETS: 'Konfiguracja ulic',
                STREETS_SUB: 'Zarządzaj ulicami',
                SETTLEMENT: 'Konfiguracja osiedli',
                SETTLEMENT_SUB: 'Zarządzaj osiedlami',
                REAL_ESTATE: 'Konfiguracja nieruchomości',
                REAL_ESTATE_SUB:
                    'Zarządzaj nieruchomościami, przypisuj osiedla do nieruchomości',
                LOCATION_TYPES: 'Typy lokalizacji',
                LOCATION_TYPES_SUB: 'Zarządzaj typami lokalizacji',
                ACCIDENT: 'Kategorie awarii',
                ACCIDENT_SUB: 'Zarządzaj kategoriami awarii',
                HOST: 'Czynności gospodarza domu',
                HOST_SUB: 'Zarządzaj czynnościami gospodarza domu',
                INHABITANT: 'Konta mieszkańców',
                INHABITANT_SUB: 'Zarządzaj kontami mieszkańców',
                ADMINS: 'Konta administratorów',
                ADMINS_SUB: 'Zarządzaj kontami administartorów',
                CONSERVATOR: 'Konta wykonawców',
                CONSERVATOR_SUB:
                    'Zarządzaj kontami wykonawców, pogotowia i konserwatorów',
                STANDARD_ISSUE_ACCEPT: 'Zatwierdzanie awarii',
                STANDARD_ISSUE_ACCEPT_SUB:
                    'Dobierz standardowe zatwierdzanie awarii',
                NONSTANDARD_ISSUE_ACCEPT: 'Niestandardowe zatwierdzanie awarii',
                NONSTANDARD_ISSUE_ACCEPT_SUB:
                    'Dobierz zatwierdzanie awarii w niestandardowe dni',
            },
            EMPLOYEE_SETTINGS_INHABITANT_ACCOUNTS: {
                ADMINISTRATION: 'Administracja',
                ADD_NEW_ACCOUNT: 'dodaj nowe konto',
                INHABITANT_LIST: 'Lista kont mieszkańców',
                DETAILS: 'Szczegóły konta',
                ADDING_NEW_ACCOUNT: 'Dodajesz nowe konto mieszkańca',
                EDIT: 'Edytujesz mieszkańca',
            },
            EMPLOYEE_SETTINGS_ADMINS: {
                ADMINISTRATION: 'Administracja',
                ADD_NEW: 'dodaj nowe konto',
                LIST: 'Lista administratorów',
                DETAILS: 'Sczegóły konta',
                ADDING_NEW_ACCOUNT: 'Dodajesz nowe konto',
                EDIT: 'Edytujesz konto',
                ACTIVATE: 'Aktywuj',
                DEACTIVATE: 'Dezaktywuj',
            },
            EMPLOYEE_SETTINGS_BUILDINGS: {
                ADMINISTRATION: 'Administracja',
                ADD_NEW: 'Dodaj nowy budynek',
                NAME: 'Nazwa budynku',
                LIST: 'Lista budynków',
                ADDING_NEW: 'Dodajesz nowy budynek',
                ADD_NEW_PART: 'Dodaj klatkę',
                ADDING_NEW_PART: 'Dodajesz klatkę',
                PROPERTY_NAME: 'Nazwa nieruchomości',
                SETTLEMENT: 'Osiedle',
                BUILDING_NAME: 'Nazwa budynku',
                BUILDING: 'Budynek',
                BUILDING_PARTS: 'Klatki',
                STAIRCASES: 'Klatki',
                NUMBER: 'Numer budynku',
                SYMBOL: 'Symbol',
                PART_NUMBER: 'Numer',
                PROPERTY_NUMBERS: 'Numery lokali',
                REAL_ESTATE: 'Nieruchomość',
                STREET: 'Ulica',
                EDIT: 'Edytujesz budynek',
                EDITING_PART: 'Edytujesz klatkę',
                HELP:
                    'Numery mieszkań można wprowadzać jako: 1-10 (wprowadzi numery od 1 do 10), a-c, 44, z.',
            },
            EMPLOYEE_SETTINGS_SETTLEMENT: {
                ADD_NEW: 'Dodaj nowe osiedle',
                LIST: 'Lista osiedli',
                ADDING_NEW: 'Dodajesz nowe osiedle',
                SETTLEMENT_NAME: 'Nazwa osiedla',
                NAME: 'Nazwa',
                EDIT: 'Edytujesz osiedle',
            },
            EMPLOYEE_SETTINGS_REAL_ESTATE: {
                ADD_NEW: 'Dodaj nową nieruchomość',
                LIST: 'Lista nieruchomości',
                ADDING_NEW: 'Dodajesz nową nieruchomość',
                SETTLEMENT_NAME: 'Nazwa osiedla',
                NAME: 'Nazwa',
                EDIT: 'Edytujesz nieruchomość',
                NUMBER: 'Numer',
            },
            EMPLOYEE_SETTINGS_STREETS: {
                ADD_NEW: 'Dodaj nową ulicę',
                LIST: 'Lista ulic',
                ADDING_NEW: 'Dodajesz nową ulicę',
                NAME: 'Nazwa ulicy',
                EDIT: 'Edytujesz ulicę',
            },
            EMPLOYEE_SETTINGS_ISSUE_CATEGORIES: {
                ADMINISTRATION: 'Administracja',
                ADD_NEW: 'dodaj nową kategorię',
                LIST: 'Lista kategorii awarii',
                ADDING_NEW: 'Dodajesz nową kategorię awarii',
                EDIT: 'Edytujesz kategorię',
                NAME: 'Nazwa kategorii',
            },
            EMPLOYEE_SETTINGS_LOCATION_TYPES: {
                ADMINISTRATION: 'Administracja',
                ADD_NEW: 'dodaj nowy typ',
                LIST: 'Lista typów',
                ADDING_NEW: 'Dodajesz nowy typ lokalizacji',
                EDIT: 'Edytujesz typ',
                NAME: 'Typ',
            },
            EMPLOYEE_SETTINGS_ISSUE_ACCEPT: {
                ADD_NON_STANDARD: 'Dodaj niestandardowy dzień',
                STANDARD_TITLE: 'Standardowe zatwierdzanie awarii',
                EDIT_STANDARD: 'Edytuj standardowe zatwierdzanie',
                NON_STANDARD_DAYS_TITLE: 'Niestandardowe dni',
                NON_STANDARD_THEMES: 'Szablony',
            },
            INHABITANT_SETTINGS_MENU: {
                ACCOUNT_SETTINGS: 'Ustawienia konta',
                ACCOUNT_SETTINGS_SUB:
                    'Zarządzaj swoimi danymi oraz danymi osoby awaryjnej',
                LOCALS: 'Lokale powiązane z kontem',
                LOCALS_SUB:
                    'Sprawdź jakie lokale są połączone z Twoim kontem. Możesz też złożyć wniosek o dodanie nowego lokalu bądź usunięcie.',
                NOTIFICATIONS: 'Ustawienia powiadomień',
                NOTIFICATIONS_SUB: 'Zmień ustawienia powiadomień',
                APP: 'Aplikacja mobilna',
                APP_SUB:
                    'Sprawdź, jak możesz połączyć aplikację mobilną systemu iMieszkaniec.pl',
                EXPORT_LIST: 'Eksportuj widok',
            },
            INHABITANT_SETTINGS_ACCOUNT_SETTINGS: {
                YOUR_DATA: 'Twoje dane',
                EMERGENCY_CONTACT_DATA: 'Dane osoby awaryjnej',
                FIRST_NAME: 'Imię',
                LAST_NAME: 'Nazwisko',
                EMAIL: 'Email',
                PHONE: 'Telefon',
                CORRESPONDENCE_ADDRESS: 'Adres korespondencyjny',
                REMARKS: 'Dane dodatkowe',
                EDIT_PASSWORD: 'Edytuj hasło',
                EDIT_DATA: 'Edytuj dane',
                CHANGE_PASSWORD: 'Edytujesz hasło',
                PASSWORD: 'Hasło',
                OLD_PASSWORD: 'Wpisz stare hasło',
                NEW_PASSWORD1: 'Nowe hasło',
                NEW_PASSWORD2: 'Powtórz nowe hasło',
                ID: 'ID z dokumentu',
            },
            INHABITANT_SETTINGS_MOBILE_APP: {
                TITLE: 'Aplikacja mobilna',
                LANE_1: 'POBIERZ DARMOWĄ APLIKACJĘ',
                LANE_2: 'System Obsługi Mieszkańca',
                LANE_3:
                    'Pobierz darmową aplikację i zaloguj się swoimi danymi. Zarządzaj swoim domem gdziekolwiek jesteś.',
            },
            INHABITANT_SETTINGS_LOCALS: {
                YOUR_LOCALS: 'Moje lokale',
            },
            SETTLEMENT: {
                REPAIR_PLANS: 'Plany remontów',
                LEGISLATIVE_ACTS_CATEGORIES: 'Kategorie aktów prawnych',
                LEGISLATIVE_ACTS: 'Akty prawne',
                HA_DOCS: 'Druki dla mieszkańca',
                TITLE: 'Tytuł',
                CATEGORY: 'Kategoria',
                ADD_FILE: 'Dodaj plik',
                NEW_FILE: 'Nowy plik',
                ENFORCABLE_DATE: 'Data obowiązywania',
                DATE: 'Data dokumentu',
                DATE_EXAMPLE: 'Przykład: 2016-06-31',
                VISIBILITY: 'Widoczność',
                VIS_MEMBER: 'Członek',
                VIS_NOTMEMBER: 'Nieczłonek',
                VIS_TENANT: 'Najemca',
            },
            PAYMENT: {
                PAYMENT_DATE_INFO:
                    'Termin płatności z tytułu opłat eksploatacyjnych i kosztów utrzymania nieruchomości upływa 20. dnia każdego miesiąca. Saldo nie uwzględnia odstetek za nieterminowe wnoszenie opłat zasądzonych kosztów sądowych.',
            },
            REPORT_OUT_ISSUE: {
                TITLE: 'Zgłoś awarię',
                SUBTITLE:
                    'Jako niezalogowany użytkownik nadal możesz zgłosić awarię. Zachęcamy jednak do rejestracji w systemie iMieszkaniec, aby być na bieżąco z jej postępem. Wypełnij poniższy formularz, aby przekazać nam informacje dotyczące problemu.',
                NAME: 'Imię i nazwisko',
                EMAIL: 'E-mail',
                PHONE: 'Telefon',
                REAL_ESTATE: 'Nieruchomość',
                BUILDING: 'Budynek',
                BUILDING_PART: 'Część budynku',
                STAIRCASE: 'Klatka',
                FLAT: 'Mieszkanie',
                CATEGORY: 'Kategoria',
                DESCRIPTION: 'Opis awarii',
                FILE: 'Załącz plik',
                ADD_ISSUE: 'Zgłoś awarię',
                REGISTRATION: 'Zarejestruj się',
                ISSUE_CATEGORY: 'Kategoria awarii',
                ISSUE_DETAILS: 'Szczegóły awarii',
            },
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/translations/translation_pl.ts